// extracted by mini-css-extract-plugin
module.exports = {"container":"menuItemFront_container__1qrdD","label":"menuItemFront_label__12b3c","btn":"menuItemFront_btn__34Q6f","price":"menuItemFront_price__1D4Sh"};
    if(module.hot) {
      // 1744882533231
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  